<script lang="ts">
  export let text: string;
  export let color: string = "hsla(226, 65%, 35%, 1)";
  export let author: string = "";
  export let size: "base" | "sm" = "base"; // Add this line
  import { reveal } from 'svelte-reveal';
</script>

<section class="mt-16 mb-16 md:mt-32 md:mb-32 py-8 md:py-16" use:reveal={{ y: 40 }}>
  <div class={`${size === 'sm' ? 'mx-auto px-4 max-w-xl bg-white z-100' : 'container mx-auto px-4 max-w-4xl bg-white z-10'}`}>
    <div class="relative">
      <span 
        class="absolute -top-8 text-[120px] leading-none text-[#F96604] font-['Times_New_Roman']"
        aria-hidden="true"
      >
        ”
      </span>
      <blockquote 
      class={`py-12 font-light ${size === "sm" ? "text-base md:text-lg" : "text-xl md:text-4xl"}`} 
        style="color: {color}; line-height: 1.4;"
      >
        {text}
      </blockquote>
      {#if author}
        <div class="mt-4 text-base text-gray-600">— {author}</div>
      {/if}
    </div>
  </div>
</section> 